import { render, staticRenderFns } from "./BtnBoxed.vue?vue&type=template&id=48eaea95&lang=pug&"
import script from "./BtnBoxed.vue?vue&type=script&lang=js&"
export * from "./BtnBoxed.vue?vue&type=script&lang=js&"
import style0 from "./BtnBoxed.vue?vue&type=style&index=0&id=48eaea95&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports